/**
 * Created by Jonas Wålekvist on 2018-05-31.
 */
import {
    ISymbolNewStateTransitionConfig,
    ISymbolOldStateTransitionConfig,
    ISymbolStateConfig,
    ISymbolStates,
    StateReelSymbol,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";

import {Timeline, TimelineLite} from "gsap";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {SpacierArcadeGameConfig} from "../SpacierArcadeGameConfig";
import {SpacierArcadeGameAssets} from "../SpacierArcadeGameAssets";
import {SAReelController} from "../reel/SAReelController";
import {SpacierArcadeModeData} from "../server/data/SpacierArcadeModeData";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";

export interface ISpacierArcadeSymbolStates extends ISymbolStates {
    reset: ISymbolStateConfig;
    noWin: ISymbolStateConfig;
    sticky: ISymbolStateConfig;
    stickyPump: ISymbolStateConfig;
    stickyIntensity: ISymbolStateConfig;
    fsStickyWild: ISymbolStateConfig;
    individualWin: ISymbolStateConfig;
    winMulti: ISymbolStateConfig;
    multiplier: ISymbolStateConfig;
    smallWin: ISymbolStateConfig;
    tinyWin: ISymbolStateConfig;
    attention: ISymbolStateConfig;
    toggle: ISymbolStateConfig;
    excitmentPump: ISymbolStateConfig;
    addFreespin: ISymbolStateConfig;
    landDead:ISymbolStateConfig;
}

export enum SASymbols {
    NONE = "none",
    L1 = "L1",
    L2 = "L2",
    L3 = "L3",
    L4 = "L4",
    M1 = "M1",
    M2 = "M2",
    M3 = "M3",
    M4 = "M4",
    W = "W",
    S = "S"
}


export class SpacierArcadeReelSymbol extends StateReelSymbol {
    protected _spine:PIXI.spine.Spine;
    protected _controller:SAReelController;
    private _multiplier:number = 0;
    private _spinIntensity:number = 1;
    private _finalMultiplier:number = 0;
    private _animationCount:number;
    private _stateTl : TimelineLite;

    set animationCount(value:number) {
        this._animationCount = value;
    }

    get animationCount():number {
        return this._animationCount;
    }

    set multiplier(value:number) {
        this._multiplier = value;
    }

    get multiplier():number {
        return this._multiplier;
    }

    set finalMultiplier(value:number) {
        this._finalMultiplier = value;
    }

    get finalMultiplier():number {
        return this._finalMultiplier;
    }

    set symbolSpinIntensity(value:number) {
        this._spinIntensity = value;
    }

    get symbolSpinIntensity():number {
        return this._spinIntensity;
    }

    get controller():SAReelController {
        return this._controller;
    }

    set controller(value:SAReelController) {
        this._controller = value;
    }

    private _genericWinContainer:PIXI.Container;
    private _winSpine:PIXI.spine.Spine;
    private _individualWinTl:TimelineLite;
    private _speedUpCoolDown:boolean;
    private _speedUpWinAnim:boolean;


    constructor(symName:string, reelId:number, state?:ISymbolStateConfig) {
        super(symName, reelId, state);

    }

    protected initAnimations():void {
        let spinName:string = this.useMainSymbols()? SpacierArcadeGameAssets.SYMBOL_STATES :SpacierArcadeGameAssets.SYMBOL_STATES_FS;
        this._spine = new PIXI.spine.Spine(GameResources.getSpineAsset(spinName));
        this._spine.autoUpdate = true;
        this._spine.skeleton.setSkinByName(this.symName);
        this._spine.name = this.symName;
        this.addChild(this._spine);
    }

    protected useMainSymbols():boolean {
        if(SpacierArcadeGameConfig.instance.reelViewExpanded !== undefined){
            return !SpacierArcadeGameConfig.instance.reelViewExpanded;
        }
        return !SpacierArcadeModeData.instance.isFreespin;
    }

    public replaceWithNewSymbolInReel(newName:string, deleteOld:boolean, state?:ISymbolStateConfig):any {
        return this._controller.replaceWithNewSymbol(this, newName, deleteOld, state);
    }

    public changeState(newStateConfig:ISymbolNewStateTransitionConfig, oldStateConfig?:ISymbolOldStateTransitionConfig):Timeline | null {
        // if(this.currentState !== SpacierArcadeGameConfig.instance.SYMBOL_STATES.spin && newStateConfig.state.keyword !== SpacierArcadeGameConfig.instance.SYMBOL_STATES.multiplier.keyword){
        //     return new TimelineLite();
        // }
        return super.changeState(newStateConfig, oldStateConfig);
    }

    protected getStateTl(state:string, stateAnimation:TimelineSprite):TimelineLite {
        const stateTl:TimelineLite = new TimelineLite();
        switch (state) {
            case SpacierArcadeGameConfig.instance.SYMBOL_STATES.normal.keyword:
                if(this._spine.state !== null) {
                    stateTl.add(new SpineTween(this._spine, 0, null));
                }
                break;
            case SpacierArcadeGameConfig.instance.SYMBOL_STATES.attention.keyword:
                if(this._spine.state !== null) {
                    stateTl.add(new SpineTween(this._spine, 0, null));
                }
                break;
            case SpacierArcadeGameConfig.instance.SYMBOL_STATES.spin.keyword:
                if(this._spine.state !== null) {
                    this._spine.state.clearTracks();
                    this._spine.skeleton.setToSetupPose();
                    this._spine.state.setAnimation(0, "spin", true);
                }
                if(this._spine.state == null){
                    debugger;
                }
                break;
            case SpacierArcadeGameConfig.instance.SYMBOL_STATES.sticky.keyword:
                if(this._spine.state !== null) {
                    stateTl.add([
                        () => {
                            if (this.symbolSpinIntensity > 1) {
                                let skinName: string = "intensity_10x";
                                if (this.symbolSpinIntensity > 2) {
                                    skinName = "intensity_30x";
                                }
                                new SpineTween(this._spine, 1, skinName, -1);
                            }
                        },
                        () => new SpineTween(this._spine, 0, "sticky", -1)
                    ]);
                }
                break;
            case SpacierArcadeGameConfig.instance.SYMBOL_STATES.stickyPump.keyword:
                if(this._spine.state !== null) {
                    stateTl.add(new SpineTween(this._spine, 0, "add_pump"));
                    stateTl.add([
                        () => {
                            if (this.symbolSpinIntensity > 1) {
                                let skinName: string = "intensity_10x";
                                if (this.symbolSpinIntensity > 2) {
                                    skinName = "intensity_30x";
                                }
                                new SpineTween(this._spine, 1, skinName, -1);
                            }
                        },
                        new SpineTween(this._spine, 0, "sticky", -1)
                    ]);
                }
                break;
            case SpacierArcadeGameConfig.instance.SYMBOL_STATES.stickyIntensity.keyword:
                if(this._spine.state !== null) {
                    stateTl.add([
                        () => {
                            if (this.symbolSpinIntensity > 1) {
                                let skinName: string = "intensity_10x";
                                if (this.symbolSpinIntensity > 2) {
                                    skinName = "intensity_30x";
                                }
                                new SpineTween(this._spine, 1, skinName, -1);
                            }
                        }
                    ]);
                }
                break;
            case SpacierArcadeGameConfig.instance.SYMBOL_STATES.win.keyword:
                if(this._spine.state !== null) {
                    stateTl.add(new SpineTween(this._spine, 0, "win_explosion"));
                }
                break;
            case SpacierArcadeGameConfig.instance.SYMBOL_STATES.noWin.keyword:
                if(this._spine.state !== null) {
                    this._spine.state.setAnimation(0, "no_win", false);
                }
                break;
            case SpacierArcadeGameConfig.instance.SYMBOL_STATES.individualWin.keyword:
                if(this._spine.state !== null) {
                    stateTl.add(new SpineTween(this._spine, 0, "toggle"));
                }
                break;
            case SpacierArcadeGameConfig.instance.SYMBOL_STATES.toggle.keyword:
                if(this._spine.state !== null) {
                    stateTl.add(new SpineTween(this._spine, 0, "toggle2"));
                }
                break;
            case SpacierArcadeGameConfig.instance.SYMBOL_STATES.excitmentPump.keyword:
                if(this._spine.state !== null) {
                    stateTl.add(new SpineTween(this._spine, 0, "excitement_pump", -1));
                }
                break;
            case SpacierArcadeGameConfig.instance.SYMBOL_STATES.tinyWin.keyword:
                if(this._spine.state !== null) {
                    stateTl.add(new SpineTween(this._spine, 0, "tiny_win"));
                    stateTl.add(() => this._spine.state.clearTrack(0));
                }
                break;
            case SpacierArcadeGameConfig.instance.SYMBOL_STATES.smallWin.keyword:
                if(this._spine.state !== null) {
                    stateTl.add(new SpineTween(this._spine, 0, "small_win"));
                    stateTl.add(() => this._spine.state.clearTrack(0));
                }
                break;
        }
        return stateTl;
    }

    protected addNewStateAnimation(timeline:TimelineLite, newState:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);
        if(this._stateTl?.isActive()){
            this._stateTl.pause().kill();
        }
        this._stateTl = this.getStateTl(newState.state.keyword, stateAnimation);
        timeline.add(this._stateTl, delay);
    }

    onRemove() {
        if(this._stateTl?.isActive()){
            this._stateTl.progress(100);
            this._stateTl.pause().kill();
        }
        super.onRemove();
    }
}